/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Loading_CargosInputs */

const en_audit_loading_cargos = /** @type {(inputs: Audit_Loading_CargosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading cargos...`)
};

const es_audit_loading_cargos = /** @type {(inputs: Audit_Loading_CargosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando cargas...`)
};

/**
* | output |
* | --- |
* | "Loading cargos..." |
*
* @param {Audit_Loading_CargosInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_loading_cargos = /** @type {((inputs?: Audit_Loading_CargosInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Loading_CargosInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_loading_cargos(inputs)
	return es_audit_loading_cargos(inputs)
});